import { MantineProvider } from "@mantine/core";
import { PropsWithChildren } from "react";

import { theme as themeV1 } from "./v1";

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  return <MantineProvider theme={themeV1}>{children}</MantineProvider>;
};
